import React from "react";
import { ReportName } from "types/gql-types";
import { ReportTable } from "./report-table";

export const ApplicationCount: React.FC = () =>
  <ReportTable reportName={ReportName.INTEREST_COUNT} includeTitle />;
